export interface AppSettings {
  navPos: 'side' | 'top';
  dir: 'ltr' | 'rtl';
  theme: 'light' | 'dark';
  showHeader: boolean;
  headerPos: 'fixed' | 'static' | 'above';
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  language?: string;
}

export const defaultAppSetings: AppSettings = {
  navPos: 'top',
  dir: 'ltr',
  theme: 'light',
  showHeader: true,
  headerPos: 'fixed',
  sidenavOpened: true,
  sidenavCollapsed: false,
};
